var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.068,
    height: 20.709,
    viewBox: "0 0 152.068 20.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6258",
    "data-name": "Group 6258",
    transform: "translate(-909 -3027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M11.1.719,8.458,6.074l-5.909.861a1.3,1.3,0,0,0-.716,2.208l4.275,4.165L5.1,19.193a1.293,1.293,0,0,0,1.876,1.363l5.286-2.778,5.286,2.778a1.294,1.294,0,0,0,1.876-1.363l-1.011-5.884,4.275-4.165a1.3,1.3,0,0,0-.716-2.208l-5.909-.861L13.42.719a1.3,1.3,0,0,0-2.321,0Z",
    transform: "translate(907.559 3027.001)",
    fill: "#f5a622"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star-2",
    "data-name": "Icon awesome-star",
    d: "M11.1.719,8.458,6.074l-5.909.861a1.3,1.3,0,0,0-.716,2.208l4.275,4.165L5.1,19.193a1.293,1.293,0,0,0,1.876,1.363l5.286-2.778,5.286,2.778a1.294,1.294,0,0,0,1.876-1.363l-1.011-5.884,4.275-4.165a1.3,1.3,0,0,0-.716-2.208l-5.909-.861L13.42.719a1.3,1.3,0,0,0-2.321,0Z",
    transform: "translate(940.167 3027.001)",
    fill: "#f5a622"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star-3",
    "data-name": "Icon awesome-star",
    d: "M11.1.719,8.458,6.074l-5.909.861a1.3,1.3,0,0,0-.716,2.208l4.275,4.165L5.1,19.193a1.293,1.293,0,0,0,1.876,1.363l5.286-2.778,5.286,2.778a1.294,1.294,0,0,0,1.876-1.363l-1.011-5.884,4.275-4.165a1.3,1.3,0,0,0-.716-2.208l-5.909-.861L13.42.719a1.3,1.3,0,0,0-2.321,0Z",
    transform: "translate(972.774 3027.001)",
    fill: "#f5a622"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star-4",
    "data-name": "Icon awesome-star",
    d: "M11.1.719,8.458,6.074l-5.909.861a1.3,1.3,0,0,0-.716,2.208l4.275,4.165L5.1,19.193a1.293,1.293,0,0,0,1.876,1.363l5.286-2.778,5.286,2.778a1.294,1.294,0,0,0,1.876-1.363l-1.011-5.884,4.275-4.165a1.3,1.3,0,0,0-.716-2.208l-5.909-.861L13.42.719a1.3,1.3,0,0,0-2.321,0Z",
    transform: "translate(1005.382 3027.001)",
    fill: "#f5a622"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star-5",
    "data-name": "Icon awesome-star",
    d: "M11.1.719,8.458,6.074l-5.909.861a1.3,1.3,0,0,0-.716,2.208l4.275,4.165L5.1,19.193a1.293,1.293,0,0,0,1.876,1.363l5.286-2.778,5.286,2.778a1.294,1.294,0,0,0,1.876-1.363l-1.011-5.884,4.275-4.165a1.3,1.3,0,0,0-.716-2.208l-5.909-.861L13.42.719a1.3,1.3,0,0,0-2.321,0Z",
    transform: "translate(1037.99 3027.001)",
    fill: "#f5a622"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.93eb9cf2.svg";
export { ForwardRef as ReactComponent };